// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import { fetchRatings } from 'syft-acp-core/api/resources'
import { takeEveryApiCall } from './helpers'

export default function* root() {
  yield takeEveryApiCall('WORKER_FEEDBACK_FETCH', fetchRatings)
}
